export default {
    HIDE_BASKET: 'hideBasket',
    SHOW_BASKET: 'showBasketMain',
    TOGGLE_BASKET: 'toggleBasket',
    TOGGLE_USER_MENU: 'toggleUserMenu',
    SHOW_USER_MENU: 'showUserMenu',
    HIDE_USER_MENU: 'hideUserMenu',
    FORCE_HIDE_BASKET: 'forceHideBasket',
    FORCE_HIDE_USER_MENU: 'forceHideUserMenu',
    TOGGLE_LANG_MENU: 'toggleLangMenu',
    HIDE_LANG_MENU: 'hideLangMenu',
    SHOW_LANG_MENU: 'showLangMenu',
};



// WEBPACK FOOTER //
// ./src/app/modules/main/config/events.constant.js